<template>
  <icon v-if="checkedCircle" :name="icon" class="w-6 h-6" :class="statusColor" />
</template>

<script>
export default {
  name: "CheckedCircle",
  data() {
    return {};
  },
  computed: {
    checkedCircle() {
      return this.params.value === "True";
    },
    icon() {
      if (this.checkedCircle) return "check-circle";
      return "x-circle";
    },
    statusColor() {
      if (this.checkedCircle) return "text-green-500";
      return "text-red-500";
    },
  },
};
</script>
